export default __webpack_public_path__ + "623f2b2d504f72a14469d121a36ce360.png";